module.exports = __webpack_public_path__ + "img/20190809162327QQ截图20190809010552.bad4851c.png";